export class PreferencesListingFilters {
    constructor() {
        try {
            return DEFAULT_LISTING_FILTERS;
        } catch (error) {
            return {};
        }
    }
}